import { createContext, useContext } from "react";
import type { BackgroundActivityContextValue } from "./types";

export const BackgroundActivityContext = createContext<BackgroundActivityContextValue | null>(null);

export function useBackgroundActivity(): BackgroundActivityContextValue {
    const value = useContext(BackgroundActivityContext);
    if (!value) {
        throw new Error("useBackgroundActivity must be used within a BackgroundActivityProvider");
    }
    return value;
}

export function useOptionalBackgroundActivity(): BackgroundActivityContextValue | null {
    return useContext(BackgroundActivityContext);
}
